import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { ScopedCssBaseline } from '@mui/material';
import theme from '../../theme';
import ConsolidatedBilling from './ConsolidatedBilling';
import PersonalBilling from './PersonalBilling';
import { fetchUser } from '../../actions/user';

const Billing = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (!user) {
      dispatch(fetchUser());
    }
  }, [user, dispatch]);

  if (user.billing_account_id) {
    return (
      <ScopedCssBaseline>
        <ThemeProvider theme={theme}>
          <ConsolidatedBilling />
        </ThemeProvider>
      </ScopedCssBaseline>
    );
  }
  return (
    <ScopedCssBaseline>
      <ThemeProvider theme={theme}>
        <PersonalBilling />
      </ThemeProvider>
    </ScopedCssBaseline>
  );
};

export default Billing;
